// api/getContactData.js
import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getContactData = () => {
  return axios.get('/contact');
};

export const useContactData = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['contact_page'],
    queryFn: () => getContactData(),
  });
};
